export { Main } from './Main';
export type { Props } from './Main.types';
